import { z } from 'zod';

export const SlackStatusSchema = z.object({
	// No 'expired' state — Slack tokens don't expire unless explicitly revoked
	status: z.enum(['connected', 'not_connected']),
});
export type SlackStatus = z.infer<typeof SlackStatusSchema>;

export const SlackAuthorizeSchema = z.object({
	redirectUrl: z.string(),
});
export type SlackAuthorize = z.infer<typeof SlackAuthorizeSchema>;

export const SlackDisconnectSchema = z.object({
	disconnected: z.boolean(),
});
export type SlackDisconnect = z.infer<typeof SlackDisconnectSchema>;
